import { defineMessages } from "react-intl";

export default defineMessages({
  serverTime: {
    id: "header.serverTime.prefix",
    defaultMessage: "Servertime:",
    description: "",
  },
});
